module.exports = __webpack_public_path__ + "img/full7-min.ff15a128.png";